import { Tag } from '@vrplatform/components';
import type { party_enum } from '@vrplatform/graphql';

type Props = {
  party: party_enum;
};

export const TagParty = ({ party }: Props) => {
  if (party === 'owners') {
    return (
      <Tag
        leftIcon={'UsersIcon'}
        leftIconColor={(theme) => theme.colors[theme.primaryColor][6]}
        size="md"
      >
        Owner
      </Tag>
    );
  }

  if (party === 'manager') {
    return (
      <Tag
        leftIcon={'BriefcaseIcon'}
        leftIconColor={(theme) => theme.colors.violet[7]}
        size="md"
      >
        Manager
      </Tag>
    );
  }

  return null;
};
